import React, { useEffect, useState } from "react";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import useOutsideClickTrigger from "../../hooks/useOutsideClickTrigger";
import "./LifeAtDropdownMenu.scss";

interface LifeAtDropdownMenuProps {
    readonly isOpen: boolean;
    /**
     * Contents of the popup menu.
     */
    readonly children: JSX.Element[];
    /**
     * Optional title for the menu.
     */
    readonly menuTitle?: string | undefined;
    /**
     * Optional description for the menu.
     */
    readonly menuDescription?: string | undefined;
    /**
     * Action to perform when closing the menu.
     */
    readonly onClose?: () => void;
    /**
     * If set, the menu will not close when the user clicks outside its
     * clickable area.
     */
    readonly ignoreOutsideClick?: boolean;
    className?: string;
}

/**
 * @deprecated Do not use this component. We need a new component that
 * contains both the button and the dropdown.
 * @param props
 * @constructor
 */
export default function LifeAtDropdownMenu(props: LifeAtDropdownMenuProps) {
    const { lightMode }: AppearanceContextType = useAppearanceContext();

    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
    useEffect(() => {
        setDropdownOpen(props.isOpen);
    }, [props.isOpen]);

    const handleClose = () => {
        if (props.onClose) {
            props.onClose();
        }
        setDropdownOpen(false);
    };

    const dropdownRef = useOutsideClickTrigger(handleClose);

    return props.isOpen && dropdownOpen ? (
        <div
            className={`lifeat-dropdown-menu dropdown-menu-content-wrapper ${lightMode ? "light" : "dark"} ${
                props.className
            }`}
            ref={props.ignoreOutsideClick ? null : dropdownRef}
        >
            {props.children}
        </div>
    ) : null;
}
